import React, {Suspense} from 'react';

import {createRoot} from 'react-dom/client';
import {IntlProvider} from 'react-intl';
import {Provider} from 'react-redux';
import {RouterProvider} from 'react-router-dom';

import {CssBaseline, StyledEngineProvider, ThemeProvider} from '@mui/material';
import {LicenseInfo} from '@mui/x-license-pro';

import {DEFAULT_LANG, MESSAGES} from '@/config/internationalization';
import constants from './config/constant';
import theme from '@/config/theme';

import store from './store';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '@/app.scss';
import routes from "@/config/routes";
import GlobalSpinner from "@/components/global-spinner.tsx";

LicenseInfo.setLicenseKey(constants.APP_MUI_X_LICENSE_KEY);

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StyledEngineProvider injectFirst>
          <IntlProvider locale={DEFAULT_LANG} messages={MESSAGES[DEFAULT_LANG]}>
            <Suspense fallback={<GlobalSpinner />}>
              <RouterProvider router={routes} />
            </Suspense>
          </IntlProvider>
        </StyledEngineProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);
